import { render, staticRenderFns } from "./detailDHL.vue?vue&type=template&id=6f6c19ae&scoped=true"
import script from "./detailDHL.vue?vue&type=script&lang=js"
export * from "./detailDHL.vue?vue&type=script&lang=js"
import style0 from "./detailDHL.vue?vue&type=style&index=0&id=6f6c19ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6c19ae",
  null
  
)

export default component.exports